<template lang='pug'>
.container
  .container
    .row.mt-5.align-items-center
      .col-sm-12.my-header.font-weight-bold
        | Аккаунт

  .container.mt-5
    .white_block
      .header-sub.pr-0.mb-4 Информация
      .loader_holder(v-show="account.loading")
        object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
      .container(v-show="!account.loading")
        .row
          .col-sm-12.mb-3
            | Название заведения
            input.card-input(
              type="text",
              placeholder="Введи название заведения",
              v-model="account.companyName"
            )
        .row
          .col-sm-6.mb-3
            | Ваше имя
            input.card-input(
              type="text",
              placeholder="Введи Ваше имя",
              v-model="account.name"
            )
          .col-sm-6.mb-3
            | Ваш номер телефона
            input.card-input(
              type="text",
              placeholder="Ваш номер телефона",
              v-mask="'+7 ### ### ## ##'",
              v-model="account.phone"
            )
          .col-sm-6.mb-3
            | Ваш email
            input.card-input(
              type="text",
              placeholder="Введи Ваш email",
              v-model="account.email"
            )
        .row
          .col-sm-10
          .col-sm-2
            button.styled.text-center.ml-auto.py-3.update(
              @click="update_user()"
            )
              | Обновить

    .white_block
      .header-sub.pr-0.mb-4 Смена пароля
      .container
        .row
          .col-sm-6.mb-3
            | Старый пароль
            input.card-input(
              type="password",
              placeholder="Введите старый пароль",
              v-model="account.password_old"
            )
          .col-sm
          .col-sm-6.mb-3
            | Новый пароль
            input.card-input(
              type="password",
              placeholder="Введите новый пароль",
              v-model="account.password_new"
            )
          .col-sm-6.mb-3
            | Подтвердите новый пароль
            input.card-input(
              type="password",
              placeholder="Введите новый пароль",
              v-model="account.password_new_copy"
            )
        .row
          .col-sm-10
          .col-sm-2
            button.styled.text-center.ml-auto.py-3.update.float-right(
              @click="update_password()"
            )
              | Обновить

    .white_block
      .header-sub.pr-0.mb-4 Договор
      .loader_holder(v-show="legal.loading")
        object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
      .container(v-show="!contract.generated && !legal.loading")
        .row
          .col-sm-12
            | Вы ещё не подписали с нами договор. Мы работаем только с юридическими лицами.
            br 
            | Договор необходим для оплаты наших услуг.
            br
            br
            b Получить договор очень просто.
            br
            | Укажите данные Вашего юридического лица.
            br
            br
        .row
          .col-sm-6.mb-3
            | Форма регистрации
            select.card-input(v-model="legal.form", placeholder="ООО или ИП")
              option(value="ООО") Общество с ограниченной ответственностью
              option(value="ИП") Индивидуальный предприниматель
          .col-sm-6.mb-3
            | Наименование организации (вместе с префиксом ООО или ИП)
            input.card-input(
              type="text",
              :placeholder="[[`${legal.form} ${legal.form == 'ООО' ? 'ПРИМЕР-М' : 'Иванов Иван Иванович'}`]]",
              v-model="legal.name"
            )
          .col-sm-6.mb-3(v-if="legal.form == 'ООО'")
            | Полное ФИО Генерального директора
            input.card-input(
              type="text",
              placeholder="Иванов Иван Иванович",
              v-model="legal.director"
            )
          .col-sm-6.mb-3
            | ИНН
            input.card-input(
              type="number",
              placeholder="0000000000",
              v-model="legal.inn"
            )
          .col-sm-6.mb-3(v-if="legal.form == 'ООО'")
            | КПП
            input.card-input(
              type="number",
              placeholder="0000000000",
              v-model="legal.kpp"
            )
          .col-sm-6.mb-3
            | Юридический адрес
            input.card-input(
              type="text",
              placeholder="101010, г.Москва, ул. Пушкина, дом 20, офис 777",
              v-model="legal.address"
            )
          .col-sm-9
          .col-sm-3
            button.styled.text-center.ml-auto.py-3.update(
              @click="create_contract()"
            )
              | Получить договор
      .container(
        v-show="contract.generated && !contract.uploadedContract && !legal.loading"
      )
        .row
          .col-sm-12
            | Договор успешно создан!
            br
            b Теперь необходимо
              a.contract_link(:href="contract.link", target="_blank") скачать
              |
              | его, подписать и загрузить обратно к нам.
            br
            br
          .col-sm-9
            input#file.contractFile(
              type="file",
              ref="file",
              v-on:change="handleContractUpload()"
            )
          .col-sm-3
            button.styled.float-right(v-on:click="uploadContract()") Загрузить документ
      .container(
        v-show="contract.uploadedContract && !contract.signed && !legal.loading"
      )
        .row
          .col-sm-12
            | Договор успешно загружен!
            br
            | Дождитесь подтверждения и подписи с нашей стороны.
            br
            br
            b Обычно мы подписываем договор в течение 2 часов.
            br
            br
      .container(v-show="contract.signed && !legal.loading")
        .row
          .col-sm-1
            i.far.fa-hands-helping.contract_signed
          .col-sm-11
            b Договор успешно заключен!
            br
            | Желаем Вам продуктивной работы и хорошего настроения!
            br
            br

    .white_block.integrations
      .header-sub.pr-0.mb-4 Ваши интеграции
      .loader_holder(v-show="connections.loading")
        object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
      .container(v-show="!connections.loading")
        .row.connection(v-for="connection in connections.list")
          .col-sm-8
            b {{ system_types[connection.type] }} -
            span.name {{ connection.connected_system }}
            br
            .account Аккаунт {{ connection.shop_identifier }}
          .col-sm.text-right
            button.styled(@click="connectionRemove(connection.id)")
              i.far.fa-trash-alt(style="margin: 0")
        .row(v-if="connections.list.length == 0")
          .col-sm
            span.no_connection 
              a(href="/account/new_pos_auth") Интегрируйте к нам
              |
              | Вашу систему учёта и используйте наши сервисы на 100%

    .white_block.api
      .header-sub.pr-0.mb-4 Интеграция с {{ franchise.name }} API
      .container
        .row(v-if="!contract.signed")
          .col-sm.unavailable
            <i class="far fa-info-circle"></i> 
            | Функция интеграции с нашими сервисами доступна только клиентам с подписанным договором.
        .row(v-if="contract.signed")
          .col-sm Вам доступна функция интеграции с нашими сервисами!
            .apiKeyLabel Ваш API-ключ:
            .apiKey 
              span(v-if="hide_api_key")
                i.far.fa-eye(@click="hide_api_key = !hide_api_key")
                | XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
              span(v-if="!hide_api_key")
                i.far.fa-eye-slash(@click="hide_api_key = !hide_api_key")
                | {{ api_key }}

        .row
          .col
            a(
              href="https://documenter.getpostman.com/view/7669154/T1LFoWAg",
              target="_blank"
            )
              button.styled
                i.far.fa-book
                | Изучить документацию для разработчиков
</template>
<script>
var apiDriver = require("../../apiDriver").default;
// import swal from "sweetalert2";
// import "sweetalert2/dist/sweetalert2.css";

export default {
  data() {
    return {
      account: {
        companyName: "",
        name: "",
        phone: "",
        email: "",
        password_old: "",
        password_new: "",
        password_new_copy: "",
        loading: true,
      },
      legal: {
        name: "",
        inn: "",
        kpp: "",
        address: "",
        director: "",
        form: "ООО",
        loading: true,
      },
      connections: {
        list: [],
        loading: true,
      },
      system_types: {
        POS: "Система учета",
      },
      contract: {
        generated: false,
        signed: false,
        link: "",
        file: "",
        uploadedContract: null,
      },
      franchise: {},
      hide_api_key: true,
      api_key: "",
    };
  },

  computed: {},

  async mounted() {
    await this.$store.dispatch("updateUserData");

    this.loadConnections();
    this.loadAccountData();

    this.franchise = this.$store.state.userData.franchise;
  },

  methods: {
    handleContractUpload() {
      this.contract.file = this.$refs.file.files[0];
    },
    async uploadContract() {
      this.legal.loading = true;
      let formData = new FormData();
      formData.append("file", this.contract.file);
      let upload = await apiDriver.documents.uploadContract(formData);
      this.legal.loading = false;
      if (!upload)
        return alert(
          "Произошла ошибка во время загрузки файла. Попробуйте обновить страницу."
        );
      this.contract.uploadedContract = upload.upload.Location;
    },
    async loadAccountData() {
      this.legal.loading = true;
      this.account.loading = true;
      let account = this.$store.state.userData; //await apiDriver.account();
      this.account.companyName = account.shop.name;
      this.account.name = account.user.name;
      this.account.phone = account.user.phone;
      this.account.email = account.user.email;
      this.contract.signed = account.documents.contract.signed;
      this.contract.generated = !!account.documents.contract.contract;
      if (this.contract.generated) {
        this.contract.link = account.documents.contract.contract.link_original;
        this.contract.uploadedContract =
          account.documents.contract.contract.link_full_signed;
      }
      if (account.documents.legal_entity.legal_entity) {
        for (let key of Object.keys(
          account.documents.legal_entity.legal_entity
        )) {
          this.legal[key] = account.documents.legal_entity.legal_entity[key];
        }
      }
      this.legal.loading = false;
      this.account.loading = false;
      this.api_key = account.user.api_key;
    },
    async loadConnections() {
      this.connections.loading = true;
      this.connections.list = (await apiDriver.connections.list()).list;
      // this.connections.loading = false;
      console.log("connections:", this.connections);
      this.connections.loading = false;
    },
    async connectionRemove(connection_id) {
      await apiDriver.connections.remove(connection_id);
      this.loadConnections();
    },
    async update_user() {
      apiDriver.settings.updateAccount({
        shop_name: this.account.companyName,
        user_name: this.account.name,
        phone: this.account.phone,
        email: this.account.email,
      });
    },
    async update_password() {
      if (this.account.password_new_copy != this.account.password_new) {
        // swal.fire({type: 'error', text: 'Указанные пароли не совпадают.', title: 'Ай!'});
        alert("Указанные пароли не совпадают.");
        return;
      }
      if (this.account.password_new_copy == "") {
        // swal.fire({type: 'error', text: 'Не получится установить пустой пароль.', title: 'Ой!'});
        alert("Не получится установить пустой пароль.");
        return;
      }
      let u = await apiDriver.settings.updatePassword({
        old_password: this.account.password_old,
        new_password: this.account.password_new,
      });
      if (!u) {
        // swal.fire({type: 'error', text: 'Во время смены пароля произошла ошибка. Скорее всего, Ваш старый пароль другой.', title: 'Упс!'});
        alert(
          "Во время смены пароля произошла ошибка. Скорее всего, Ваш старый пароль другой."
        );
        return;
      }
      this.$toast.success("Пароль успешно обновлён!");
      this.account.password_old = this.account.password_new;
      this.account.password_new = "";
      this.account.password_new_copy = "";
    },
    async create_contract() {
      // validation
      let wrong = 0;
      if (this.legal.form == "ООО") {
        if (this.legal.inn.replace(/\s/g, "") == "") wrong++;
        if (this.legal.kpp.replace(/\s/g, "") == "") wrong++;
        if (this.legal.address.replace(/\s/g, "") == "") wrong++;
        if (this.legal.director.replace(/\s/g, "") == "") wrong++;
        if (this.legal.name.replace(/\s/g, "") == "") wrong++;
        if (!this.legal.name.includes("ООО")) wrong++;
      }
      if (this.legal.form == "ИП") {
        if (this.legal.inn.replace(/\s/g, "") == "") wrong++;
        if (this.legal.address.replace(/\s/g, "") == "") wrong++;
        if (this.legal.name.replace(/\s/g, "") == "") wrong++;
        if (!this.legal.name.includes("ИП")) wrong++;
      }
      if (wrong)
        return alert(
          "Пожалуйста, заполните все поля и проверьте их на отсутствие ошибок."
        );

      this.legal.loading = true;
      let x = await apiDriver.documents.create_contract(this.legal);
      this.legal.loading = false;
      if (!x) {
        alert(
          "Произошла ошибка во время создания договора. Попробуйте обновить страницу."
        );
        return;
      }

      this.contract.generated = true;
      this.contract.link = x.pdf.upload.Location;
    },
  },
};
</script>
<style scoped lang="stylus">
.white_block {
  background: white;
  margin: 5px;
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 7px;
}

.my-header {
  font-size: 26pt;
}

.header-sub {
  // color: white;
  font-size: 1.5rem;
}

.card-input {
  width: 100%;
  margin-top: 7px;
  border: none;
  outline: none;
  background-color: transparent;
  color: black;
  font-weight: normal;
  border-bottom: 1px solid #ddd;
  transition: border-bottom 0.6s;

  &:focus {
    border-bottom: 1px solid #6c68cb;
  }
}

.account-money {
  font-weight: bold;
  font-size: 1.5rem;
  font-weight: normal;
  cursor: default;
}

a {
  color: #6c68cb !important;
}

button.update {
  width: 100%;
}

.contractFile {
  border: 1px solid #eee;
  padding: 7px;
  border-radius: 4px;
  width: 100%;
}

i.contract_signed {
  font-size: 46px;
  color: #707bd7;
}

.integrations {
  padding-bottom: 30px;
}

.connection .name {
  margin-left: 5px;
}

@media (prefers-color-scheme: dark) {
  .card-input {
    background-color: #282828 !important;
    border-color: #4a4a4a;
    color: white !important;
  }
}
</style>
